import React, { useEffect, useRef, useState } from 'react';
import profileImage from '../image/images (7).jpg';

export default function About() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" ref={sectionRef} style={styles.aboutSection} className="py-4 py-lg-5 overflow-hidden">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;800;900&family=Poppins:wght@400;500;600;700&display=swap');

        /* सुरुवातीला लपवून ठेवण्यासाठी */
        .fade-item {
          opacity: 0;
        }

        /* Fade In Left Keyframes (इमेजसाठी - डावीकडून) */
        @keyframes fadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-60px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        /* Fade In Right Keyframes (कंटेंटसाठी - उजवीकडून) */
        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(60px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        /* स्क्रोल झाल्यावर लागू होणारे क्लास */
        .start-fade-left {
          animation: fadeInLeft 1.2s cubic-bezier(0.22, 1, 0.36, 1) forwards;
        }

        .start-fade-right {
          animation: fadeInRight 1.2s cubic-bezier(0.22, 1, 0.36, 1) forwards;
        }

        /* Content साठी थोडा उशिरा (Delay) ॲनिमेशन होण्यासाठी */
        .content-delay {
          animation-delay: 0.2s;
        }

        /* Image Hover Zoom Effect */
        .img-zoom-effect {
          transition: transform 0.4s ease-in-out !important;
        }
        .img-zoom-effect:hover {
          transform: scale(1.08) !important;
        }

        /* Cards Hover Animation */
        .card-box-anim {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .card-box-anim:hover {
          transform: translateY(-6px);
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12) !important;
        }

        /* Mobile आणि Tablet Responsiveness */
        @media (max-width: 991.98px) {
          .about-img-wrapper {
            margin-bottom: 2.5rem;
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
            width: 100%;
          }
          .about-img-wrapper > div {
            width: auto !important;
            display: flex !important;
            justify-content: center !important;
          }
          .about-content {
            text-align: center; 
            padding-left: 0 !important;
          }
          .about-content .row {
            justify-content: center;
          }
        }
      `}</style>

      <div className="container-fluid py-2 py-lg-3">
        <div className="row align-items-center">
          
          {/* Left Column: Image with Fade-In-Left */}
          <div 
            className={`col-lg-5 mb-4 mb-lg-0 text-center about-img-wrapper fade-item ${
              isVisible ? 'start-fade-left' : ''
            }`}
          >
            <div style={styles.imgSplashWrapper}>
              
              {/* बाहेरचा DIV */}
              <div style={styles.outerBorderDiv}>
                
                {/* आतील DIV */}
                <div style={styles.innerImgDiv}>
                  <img 
                    src={profileImage}   
                    alt="Parag Patil Portrait"
                    style={styles.aboutImg}
                    className="img-fluid img-zoom-effect"
                  />
                </div>

              </div>

            </div>
          </div>

          {/* Right Column: About Content with Fade-In-Right + Slight Delay */}
          <div 
            className={`col-lg-7 ps-lg-4 about-content fade-item ${
              isVisible ? 'start-fade-right content-delay' : ''
            }`}
          >
            
            {/* Centered ABOUT ME */}
            <div className="d-flex align-items-center justify-content-center mb-3 gap-3">
              <div style={{ width: '50px', height: '3px', backgroundColor: '#FF9933', borderRadius: '2px' }}></div>
              <span style={styles.sectionBadge}>ABOUT ME</span>
              <div style={{ width: '50px', height: '3px', backgroundColor: '#138808', borderRadius: '2px' }}></div>
            </div>

            <h2 style={styles.sectionHeading}>Hi, I'm Paarag Patil</h2>
            <p style={styles.aboutText}>
              I'm Parag Patil from Chinchwad, Pune. I am a professional athlete representing India in the events <strong>100m Run, Long Jump & Triple Jump</strong>.
              A successful journey of winning <strong style={{ color: '#FF9933' }}>2 Gold</strong>, <strong style={{ color: '#000080' }}>7 Silver</strong> & <strong style={{ color: '#138808' }}>3 Bronze Medals</strong> for our Nation.
            </p>

            <div className="row g-3 mt-2 text-start">
              <div className="col-12 col-sm-6 col-md-4">
                <div className="card-box-anim" style={{ ...styles.cardBox, borderTop: '4px solid #FF9933' }}>
                  <div style={styles.cardIcon}>🥇</div>
                  <div style={{ ...styles.cardTitle, color: '#FF9933' }}>DEBUT</div>
                  <p style={styles.cardDesc}>
                    Won 3 Medals in World Masters Games (Senior Olympic) Torino Italy 2013
                  </p>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-md-4">
                <div className="card-box-anim" style={{ ...styles.cardBox, borderTop: '4px solid #000080' }}>
                  <div style={styles.cardIcon}>🎯</div>
                  <div style={{ ...styles.cardTitle, color: '#000080' }}>AMBITION</div>
                  <p style={styles.cardDesc}>Win 100 Medals for India in Athletics</p>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-md-4">
                <div className="card-box-anim" style={{ ...styles.cardBox, borderTop: '4px solid #138808' }}>
                  <div style={styles.cardIcon}>⭐</div>
                  <div style={{ ...styles.cardTitle, color: '#138808' }}>MEMORABLE</div>
                  <p style={styles.cardDesc}>Won Silver Medal in World Masters Games 2017 Auckland in Triple Jump on second day after major accident.</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

const styles = {
  aboutSection: { 
    backgroundColor: '#ffffff',
    fontFamily: "'Poppins', sans-serif",
  },
  imgSplashWrapper: {
    position: 'relative',
    display: 'inline-block',
    width: '100%',
    maxWidth: '500px',
  },
  
  outerBorderDiv: {
    position: 'relative',
    width: '100%',
    border: '4px solid #CC5500',
    borderRadius: '16px',
    zIndex: 1,
  },
  
  innerImgDiv: {
    position: 'relative',
    transform: 'translate(-16px, -16px)',
    zIndex: 2,
    borderRadius: '16px',
    overflow: 'hidden',
    backgroundColor: '#ffffff',
  },
  
  aboutImg: {
    width: '100%',
    height: 'auto',
    borderRadius: '16px',
    boxShadow: '0 10px 25px rgba(0,0,0,0.12)',
    objectFit: 'cover',
    display: 'block',
  },

  sectionBadge: {
    color: '#000080',
    fontWeight: '600',
    fontSize: '22px',
    letterSpacing: '4px',
    whiteSpace: 'nowrap',
    padding: '0 5px',
    fontFamily: "'Montserrat', sans-serif",
  },
  sectionHeading: { 
    fontWeight: '600', 
    color: '#000080', 
    fontSize: 'clamp(24px, 4vw, 32px)',
    marginBottom: '12px',
    fontFamily: "'Montserrat', sans-serif",
  },
  aboutText: { 
    fontSize: '17px', 
    lineHeight: '1.7', 
    color: '#334155',
    marginBottom: '16px',
    fontFamily: "'Poppins', sans-serif",
  },
  cardBox: {
    backgroundColor: '#fff',
    border: 'none',
    borderRadius: '12px',
    padding: '20px 16px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 6px 18px rgba(0, 0, 0, 0.06)',
  },
  cardIcon: { fontSize: '22px' },
  cardTitle: { 
    fontWeight: '800', 
    fontSize: '17px', 
    marginTop: '6px',
    marginBottom: '8px',
    fontFamily: "'Montserrat', sans-serif",
  },
  cardDesc: { 
    fontSize: '15px', 
    color: '#222', 
    margin: 0, 
    lineHeight: '1.6',
    minHeight: '85px', /* कार्ड्समधील पॅराग्राफची उंची वाढवण्यासाठी */
    display: 'flex',
    alignItems: 'flex-start',
    fontFamily: "'Poppins', sans-serif",
  },
};
